import { useState } from "react";
import { useNavigate } from "react-router-dom";
import GetSvgIcon from "../../../../assets/images/svgList";
import FormButton from "../../../../Components/Buttons/FormButton";
import Table, { Column } from "../../../../Components/Tables/Table";
import { checkInDetailsData } from "../../../../Data/testData";
import { generateRandom10DigitNumber } from "../../../../Utility/Utility";
import { ScanItem } from "../../Unload/Unload.type";
import { ReturnReceiveItem } from "./ReturnReceiveItem.type";
import { itemConditionList } from "../../../../Data/dropdownDataList";

export default function ReturnReceiveAddEdit() {
  const [quantity, setQuantity] = useState<String>("");
  const [trackingNo, setTrackingNo] = useState(0);
  const [unloadSuccessMsg, setUnloadSuccessMsg] = useState("");
  const [itemData, setItemData] = useState<ScanItem>(new ScanItem());
  const [receiveItemList, setReceiveItemList] = useState<ReturnReceiveItem[]>(
    []
  );
  const [selectedColor, setSelectedColor] = useState(itemConditionList[0].color);

  const handleSelectChange = (event: any) => {
    const selectedOption = itemConditionList.find(item => item.value === event.target.value);
    if (selectedOption) {

      setSelectedColor(selectedOption.color);
    }
  };

  const [errMsg, setErrMsg] = useState("");
  const [isShowErr, setShowErr] = useState(false);
  const [hideErrMsgTimeout, setHideErrMsgTimeout] =
    useState<NodeJS.Timeout | null>(null);
  const navigation = useNavigate();
  const handleCancelBtn = () => {
    navigation("/inbound/returns/receive");
  };
  let numbers = generateRandom10DigitNumber(1000000000, 9999999999);
  const handelItemQuantity = (val: string) => {
    if (val !== "") {
      const matchedItem: ReturnReceiveItem | undefined =
        checkInDetailsData.find((e) => e.ItemCode.text === val);
      if (matchedItem) {
        setTrackingNo(numbers);
        setQuantity(matchedItem.ReceivedQuantity);
        setReceiveItemList((prevList) => {
          const itemExists = prevList.some(
            (item) => item.Line === matchedItem?.Line
          );
          if (!itemExists) {
            return [...prevList, matchedItem];
          }
          return prevList;
        });
        setUnloadSuccessMsg("");
      } else {
        setShowErr(true);
        setErrMsg("Code not found");
        const timeout = setTimeout(() => {
          setShowErr(false);
          setErrMsg("");
        }, 2000);

        setHideErrMsgTimeout(timeout);
      }
    } else {
      setQuantity("");
      setTrackingNo(0);
    }
  };

  function getOptionClass(color: any) {
    switch (color) {
      case 'green':
        return 'green-option';
      case 'black':
        return 'black-option';
      case 'red':
        return 'red-option';
      case 'blue':
        return 'blue-option';
      default:
        return '';
    }
  }


  const columns: Column[] = [
    {
      name: "Line#",
      selector: (row: { Line: string }) => row.Line,
    },
    {
      name: "Items",
      selector: (row: { ItemCode: { imgSrc: string; text: string } }) => (
        <div>
          {row.ItemCode.imgSrc && (
            <img
              src={require(`../../../../assets/images/${row.ItemCode.imgSrc}`)}
              alt={row.ItemCode.text}
              style={{ width: "20px", marginRight: "8px" }}
            />
          )}
          {row.ItemCode.text}
        </div>
      ),
    },
    {
      name: "UOM",
      selector: (row: { UOM: string }) => row.UOM,
    },
    {
      name: "Received Qty",
      selector: (row: { ReceivedQuantity: string }) => row.ReceivedQuantity,
    },
  ];

  const receiveListcolumns: Column[] = [
    {
      name: "Line#",
      selector: (row: { Line: string }) => row.Line,
    },
    {
      name: "Items",
      selector: (row: { ItemCode: { imgSrc: string; text: string } }) => (
        <div>
          {row.ItemCode.imgSrc && (
            <img
              src={require(`../../../../assets/images/${row.ItemCode.imgSrc}`)}
              alt={row.ItemCode.text}
              style={{ width: "20px", marginRight: "8px" }}
            />
          )}
          {row.ItemCode.text}
        </div>
      ),
    },
    {
      name: "UOM",
      selector: (row: { UOM: string }) => row.UOM,
    },
    {
      name: "Received Qty",
      selector: (row: { ReceivedQuantity: string }) => "-",
    },
    {
      name: "Expected Qty",
      selector: (row: { ReceivedQuantity: string }) => row.ReceivedQuantity,
    },
  ];
  const handleSaveBtn = () => {
    if (receiveItemList.length === 0) {
      setShowErr(true);
      setErrMsg("Enter Item/UPC");
      const timeout = setTimeout(() => {
        setShowErr(false);
        setErrMsg("");
      }, 2000);

      setHideErrMsgTimeout(timeout);
    } else {
      navigation("/inbound/returns/receive");
    }
  };
  const handleRowClick = (data: ReturnReceiveItem) => {
    setQuantity(data.ReceivedQuantity);
    setTrackingNo(numbers);
    setReceiveItemList((prevList) =>
      prevList.some((item) => item.Line === data.Line)
        ? prevList
        : [...prevList, data]
    );
  };
  return (
    <div>
      <div className="d-flex flex-column h-100">
        <div className="d-flex justify-content-start mt-3">
          {isShowErr && (
            <div
              className="alert alert-danger text-center position-fixed alert-on-top"
              role="alert"
            >
              {errMsg}
            </div>
          )}
          <div className="col">
            <div className="top-tab p-3">
              <div className="">
                ASN: <strong>B5487996</strong>
              </div>
            </div>
          </div>
          <div className="col mx-2">
            <div className="top-tab p-3">
              <div className="">
                Location: <strong>19-Door</strong>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="top-tab p-3">
              <div className="">
                Warehouse: <strong>Area-12</strong>
              </div>
            </div>
          </div>
          <div className="col mx-2">
          <div className="top-tab p-3">
              <div className="">
                Tracking #: <strong>12345678</strong>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between my-3">
          <div className="col d-flex flex-column justify-content-between scanning-area">
            <div className="d-flex align-items-center justify-content-around scanning-area-top">
              Enter Item/UPC # to Start receiving.
            </div>
            {
              quantity !== "" && (
                <div className="item-condition-div d-flex justify-content-between py-2 px-3 position-relative">
                  <label>
                    Select Item Condition
                  </label>
                  <select
                    className="custom-dropdown colouredOption position-absolute end-0 w-100"
                    style={{ color: selectedColor }}
                    onChange={handleSelectChange}
                  >
                    {itemConditionList.map((item) => (
                      <option key={item.value} value={item.value} style={{ color: item.color }}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                </div>
              )
            }

            <div className="bg-white p-4 scanning-area-bottom">

              <div className="input-group">
                <input
                  type="text"
                  className="form-control rounded-start-pill  border border-info border-end-0 p-3 scanner-input"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-lg"
                  placeholder="Scan or Enter Item / UPC #"
                  onKeyDown={(e) => {
                    if (e.key === "Tab" || e.key === "Enter") {
                      handelItemQuantity((e.target as HTMLInputElement).value);
                    } else if (e.key === "Backspace" || e.key === "Delete") {
                      handelItemQuantity("");
                      setTrackingNo(0);
                    }
                  }}
                />
                <span
                  className="input-group-text rounded-end-pill bg-white border border-info border-start-0 cursor-pointer"
                  id="inputGroup-sizing-lg"
                >
                  {GetSvgIcon.UpcScanner}
                </span>
              </div>
            </div>
            <div className="d-flex justify-content-between mt-2">
              <div className="col me-1">
                <div className="top-tab p-3 d-flex justify-content-between">
                  <div className="">
                    <strong>Quantity:</strong>
                  </div>
                  <div className="">
                    <strong>{quantity}</strong>
                  </div>
                </div>
              </div>
              <div className="col ms-1">
                <div className="top-tab p-3 d-flex justify-content-between">
                  <div className="">
                    <strong>Item/UPC:</strong>
                  </div>
                  <div className="">
                    <strong>{trackingNo > 0 ? trackingNo : ""}</strong>
                  </div>
                </div>
              </div>
            </div>

            <div className="justify-content-between ">
              <Table
                columns={columns}
                data={checkInDetailsData}
                handleRowClick={handleRowClick}
                CheckboxStatus={false}
              />
            </div>
          </div>
          <div className="col-8 ms-2">
            <div className="top-tab h-100 p-2">
              {receiveItemList.length > 0 ? (
                <Table
                  columns={receiveListcolumns}
                  data={receiveItemList}
                  CheckboxStatus={false}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div className="mt-auto bg-white rounded py-3 d-flex justify-content-end">
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <FormButton
                tabIndex={12}
                className="sph-btn sph-shift me-4"
                handleClick={handleCancelBtn}
              >
                Close
              </FormButton>
              <FormButton
                tabIndex={11}
                className="sph-btn me-4"
                handleClick={handleSaveBtn}
              >
                Submit
              </FormButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
